import { render, staticRenderFns } from "./surveyAnswerPage.vue?vue&type=template&id=7951a478&scoped=true&"
import script from "./surveyAnswerPage.vue?vue&type=script&lang=ts&"
export * from "./surveyAnswerPage.vue?vue&type=script&lang=ts&"
import style0 from "./surveyAnswerPage.vue?vue&type=style&index=0&id=7951a478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7951a478",
  null
  
)

export default component.exports